import React from "react";
import ChatbotDashboard from "./ChatbotDashboard";

function App() {
  return (
    <div className="App">
      <ChatbotDashboard />
    </div>
  );
}

export default App;
